<template>
    <div id="About" class="page" data-page="teaching-toolkit">
        <appModal ref="appModalRef" :countries="DBCountries"></appModal>
        <appHeader bgColor="blue" @headerMenuClicked="menuClicked" page="about"></appHeader>
        <div class="main">
            <div class="main_inner">
                <section class="main_section">
                    <div class="section_content">
                        <h1 class="title_page text_title2">
                            Teaching Toolkit
                        </h1>
                        <p class="text_p">The teaching toolkit of the Atlas of the Offshore World offers multiple tools to facilitate the engagement of young people in discussions related to illicit financial flows, tax evasion and avoidance. The toolkit consists of explainer videos, research tasks, readings, tutorials, quizes, and workshop instructions. The tools are modular: the teacher can select the tools that fit the educational programme and combine them with other activities. This toolkit was developed by Skatteforsk - Norwegian Centre for Tax Research supported by funding from the Norwegian Finance Market Fund.</p>
                    </div>
                </section>

                <section class="main_section section_about">
                    <div class="section_content">

                        <div class="toolkit_hero">
                            <img class="toolkit_hero_image" src="/images/toolkit/teaching-toolkit-logo.png" alt="Teaching Toolkit" />
                        </div>

                        <div class="toolkit_sections">
                            <div class="toolkit_section" v-for="(item, index) in toolkitItems" :key="index">
                                <div class="toolkit_section_icon">
                                    <img :src="item.icon" :alt="item.title" />
                                </div>
                                <div class="toolkit_section_content">
                                    <h3 class="toolkit_section_title">{{ item.title }}</h3>
                                    <p class="toolkit_section_text">{{ item.text }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="toolkit_cta">
                            <h2 class="toolkit_cta_title">Do you want to use the teaching toolkit?</h2>
                            <p class="toolkit_cta_text">Get in touch with us at <a href="mailto:contact@atlas-offshore-world.org">contact@atlas-offshore-world.org</a> with any questions or ideas to further develop the toolkit.</p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <appFooter></appFooter>
        <cookiesConsent></cookiesConsent>
    </div>
</template>

<script>
    import * as d3 from 'd3'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import {_} from 'underscore'
    var slugify = require("underscore.string/slugify")
    var numberFormat = require('underscore.string/numberFormat')

    import appHeader from '~/components/appHeader.vue'
    import appFooter from '~/components/appFooter.vue'
    import appModal from '~/components/appModal.vue'
    import cookiesConsent from '~/components/cookiesConsent.vue'

    export default {
        components: {
            "appHeader": appHeader,
            "appFooter": appFooter,
            "appModal": appModal,
            "cookiesConsent": cookiesConsent
        },

        data: function () {
            return {
                isDataLoaded: false,
                DBCountries: [],
                toolkitItems: [
                    {
                        title: 'Videos',
                        icon: '/images/toolkit/icon-videos.svg',
                        text: "'Follow the Money' a 3 part mini-documentary series explores how different illicit economic practices erode the fairness of tax systems around the world and threaten the foundations of democracy. Through interviews with economic researchers, state authorities and journalists, 'Follow the Money' invites students to use the Atlas of the Offshore World as a research-based information tool to keep the market and governments accountable."
                    },
                    {
                        title: 'Tasks',
                        icon: '/images/toolkit/icon-tasks.svg',
                        text: "Each part of 'Follow the Money' touches on different illicit economic activities and introduces economic concepts in an entertaining format. To reinforce the learning outcome we provide, per film, a list of questions for individual assessment and group discussions, plus a creative and a research task."
                    },
                    {
                        title: 'Readings',
                        icon: '/images/toolkit/icon-readings.svg',
                        text: "The topics presented in each video can be explored further by our list of helpful readings that includes research papers, Op-eds and scientific dissemination texts."
                    },
                    {
                        title: 'Tutorials',
                        icon: '/images/toolkit/icon-tutorial.svg',
                        text: "Using the Atlas can be daunting at first. Check out our video tutorials that will help you to find answers to multiple questions."
                    },
                    {
                        title: 'Quiz',
                        icon: '/images/toolkit/icon-quiz.svg',
                        text: "Test the knowledge on the Atlas of the Offshore World with fun quizzes."
                    },
                    {
                        title: 'Workshop',
                        icon: '/images/toolkit/icon-workshop.svg',
                        text: "Leverage the toolkit with a fun dynamic that physically activates the students."
                    }
                ]
            }
        },

        created: function () {

        },

        mounted: function () {
            var self = this;
            this.loadCountriesMetadata();
        },

        methods: {
            loadCountriesMetadata: function (){
                var self = this;

                UTILS.loadCountriesCSVData().then(function (callbackDBCountries){
                    self.DBCountries = JSON.parse(JSON.stringify(callbackDBCountries.dbCountries));
                }).catch(err => {
                console.log(err);
              });
            },

            openModal: function (modalType){
                this.$refs.appModalRef.openModal(modalType);
            },

            menuClicked: function (menuType){
                this.openModal(menuType)
            },
        },

        watch: {

        }
    }

</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    #About[data-page="teaching-toolkit"]{
        .content_title{
            margin-bottom: 20px;
        }
    }

    #About[data-page="teaching-toolkit"] .main{
        background: #fff;
        .main_inner{
            .main_section{
                &.section_about{
                    margin-top: 60px;
                    padding: 0px 0 60px;
                    background: #EEF1F6;
                }
            }
        }
    }

    .toolkit_hero{
        text-align: center;
        margin: 40px 0 30px;
        .toolkit_hero_word{
            display: block;
            font-size: 28px;
            font-weight: 700;
            line-height: 1.2;
        }
        .toolkit_hero_teaching{ color: $colorBlue; }
        .toolkit_hero_toolkit{ color: $colorOrange; margin-top: 8px; }
        .toolkit_hero_image{
            display: block;
            max-width: 100%;
            height: auto;
            margin: 16px auto 0;
            max-height: 280px;
            object-fit: contain;
        }
    }

    .toolkit_sections{
        margin-top: 48px;
    }
    .toolkit_section{
        display: flex;
        align-items: flex-start;
        gap: 28px;
        margin-bottom: 16px;
        background: #fff;
        border-radius: 16px;
        padding: 30px 24px;
        .toolkit_section_icon{
            flex-shrink: 0;
            width: 100px;
            img{
                width: 100%;
                height: auto;
                display: block;
                position: relative;
                top: -10px;
            }
        }
        .toolkit_section_content{
            flex: 1;
            min-width: 0;
        }
        .toolkit_section_title{
            font-size: 24px;
            font-weight: 700;
            color: $colorBlue;
            margin: 0 0 16px;
            line-height: 100%;
        }
        .toolkit_section_text{
            font-size: 18px;
            line-height: 170%;
            color: $colorBlack;
            margin: 0;
        }
    }

    .toolkit_cta{
        text-align: center;
        margin-top: 16px;
        padding-top: 24px;
        border-top: 1px solid #BAC6DF;
        .toolkit_cta_title{
            font-size: 24px;
            font-weight: 700;
            color: $colorBlue;
            margin: 0 0 16px;
            line-height: 1.3;
        }
        .toolkit_cta_text{
            font-size: 18px;
            line-height: 30px;
            color: $colorBlack;
            margin: 0;
            a{
                color: $colorBlue;
                font-weight: 700;
                text-decoration: underline;
                &:hover{ text-decoration: underline; }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// pages/teaching-toolkit/index.vue